var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".module-title[data-v-a2998814]{width:100%;background:url(" + escape(require("../../assets/img/detail/title-bg.png")) + ") 50%;background-size:auto 100%}.module-title h2[data-v-a2998814]{height:37px;text-align:center;font-size:1rem;line-height:37px}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/module-title.vue"],"names":[],"mappings":"AACA,+BACE,WAAY,AACZ,6CAA6D,AAC7D,yBAA2B,CAC5B,AACD,kCACE,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACnB","file":"module-title.vue","sourcesContent":["\n.module-title[data-v-a2998814] {\n  width: 100%;\n  background: url(../../assets/img/detail/title-bg.png) center;\n  background-size: auto 100%;\n}\n.module-title h2[data-v-a2998814]{\n  height: 37px;\n  text-align: center;\n  font-size: 1rem;\n  line-height: 37px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2998814","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detail/module-title.vue
// module id = hT17
// module chunks = 1